import { cx } from "../../styled-system/css";
import { styles } from "../styles";

type Props = {
  checked: boolean;
  disabled?: boolean;
  label: string;
  onChange: (checked: boolean) => void;
};

export function OwnershipCheckbox(props: Props) {
  return (
    <button
      class={cx(styles.ownershipToggle, props.disabled && styles.ownershipToggleDisabled)}
      type="button"
      title={props.label}
      role="checkbox"
      aria-checked={props.checked}
      aria-label={props.label}
      disabled={props.disabled}
      onClick={() => props.onChange(!props.checked)}
    >
      <span
        class={styles.ownershipIndicator}
        style={{
          "background-color": props.checked ? "var(--theme-success)" : "transparent",
          color: props.checked ? "var(--theme-accent-contrast)" : "transparent",
        }}
        aria-hidden="true"
      >{props.checked ? "✓" : ""}</span>
    </button>
  );
}
